module.exports = __webpack_public_path__ + "static/media/sg.71de645b.svg";